import AuthenticationService from '@lib/auth/AuthenticationService';

const logUserOut = () => async (dispatch) => {
	// Reset the auth tokens
	const auth = new AuthenticationService();
	auth.logUserOut();

	// Then set the global data here.
	dispatch({
		type: 'UNSET_USER',
	});
};

export default logUserOut;
